import classes from "./styles.module.scss";
import { Component } from "react";
import React from "react";
import classNames from "classnames";

interface IProps {
  src: string;
  alt: string;
  big?: boolean;
  medium?: boolean;
  normal?: boolean;
  small?: boolean;
  extraSmall?: boolean;
  rounded?: boolean;
  fitHeight?: boolean;
  fitWidth?: boolean;
}

class Image extends Component<IProps & React.HTMLAttributes<HTMLImageElement>> {
  render() {
    const {
      className,
      big,
      medium,
      small,
      extraSmall,
      alt,
      rounded,
      fitHeight,
      fitWidth,
      normal
    } = this.props;
    const imageClass = classNames(
      classes.Image,
      big ? classes.big : "",
      medium ? classes.medium : "",
      small ? classes.small : "",
      extraSmall ? classes.extraSmall : "",
      rounded ? classes.rounded : "",
      fitHeight ? classes.fitHeight : "",
      fitWidth ? classes.fitWidth : "",
      normal ? classes.normal : "",
      className
    );
    return (
      <div className={imageClass}>
        <img src={this.props.src} alt={alt} />
      </div>
    );
  }
}
export default Image;
